import axios from 'axios';
import {
  SALARY_UPLOAD_REQUEST,
  SALARY_UPLOAD_SUCCESS,
  SALARY_UPLOAD_FAIL,
  SALARY_CREATE_REQUEST,
  SALARY_CREATE_SUCCESS,
  SALARY_CREATE_FAIL,
  SALARY_LIST_REQUEST,
  SALARY_LIST_SUCCESS,
  SALARY_LIST_FAIL,
  SALARY_DETAILS_REQUEST,
  SALARY_DETAILS_SUCCESS,
  SALARY_DETAILS_FAIL,
  SALARY_UPDATE_REQUEST,
  SALARY_UPDATE_SUCCESS,
  SALARY_UPDATE_FAIL,
  SALARY_DELETE_REQUEST,
  SALARY_DELETE_SUCCESS,
  SALARY_DELETE_FAIL,
  SALARY_BULK_DELETE_REQUEST,
  SALARY_BULK_DELETE_SUCCESS,
  SALARY_BULK_DELETE_FAIL,
  SALARY_STATS_REQUEST,
  SALARY_STATS_SUCCESS,
  SALARY_STATS_FAIL,
  SALARY_APPROVE_REQUEST,
  SALARY_APPROVE_SUCCESS,
  SALARY_APPROVE_FAIL,
  SALARY_APPROVE_ALL_REQUEST,
  SALARY_APPROVE_ALL_SUCCESS,
  SALARY_APPROVE_ALL_FAIL,
  SALARY_HOLD_REQUEST,
  SALARY_HOLD_SUCCESS,
  SALARY_HOLD_FAIL,
  SALARY_GENERATE_REQUEST,
  SALARY_GENERATE_SUCCESS,
  SALARY_GENERATE_FAIL,
} from '../constants/salaryConstants';

const baseUrl = process.env.REACT_APP_API_URL;

// Upload Salary Excel
export const uploadSalaryExcel = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_UPLOAD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/salary/upload`, formData, config);

    dispatch({
      type: SALARY_UPLOAD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_UPLOAD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Create Single Salary Record
export const createSalaryRecord = (salaryData) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/salary`, salaryData, config);

    dispatch({
      type: SALARY_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get All Salary Records
export const listSalaryRecords = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const queryParams = new URLSearchParams(filters).toString();
    const { data } = await axios.get(`${baseUrl}/salary?${queryParams}`, config);

    dispatch({
      type: SALARY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get Salary By ID
export const getSalaryDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(`${baseUrl}/salary/${id}`, config);

    dispatch({
      type: SALARY_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_DETAILS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update Salary Record
export const updateSalaryRecord = (id, updateData) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/salary/${id}`, updateData, config);

    dispatch({
      type: SALARY_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Delete Salary Record
export const deleteSalaryRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${baseUrl}/salary/${id}`, config);

    dispatch({
      type: SALARY_DELETE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: SALARY_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Bulk Delete Salary Records
export const bulkDeleteSalaryRecords = (month, year) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_BULK_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.delete('${baseUrl}/salary/bulk', {
      data: { month, year },
      ...config,
    });

    dispatch({
      type: SALARY_BULK_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_BULK_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Get Salary Statistics
export const getSalaryStats = (filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_STATS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const queryParams = new URLSearchParams(filters).toString();
    const { data } = await axios.get(`${baseUrl}/salary/stats?${queryParams}`, config);

    dispatch({
      type: SALARY_STATS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_STATS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Approve Salary Record
export const approveSalaryRecord = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_APPROVE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/salary/${id}/approve`, {}, config);

    dispatch({
      type: SALARY_APPROVE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_APPROVE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Approve All Salary Records
export const approveAllSalaryRecords = (approvalData) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_APPROVE_ALL_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/salary/approve-all`, approvalData, config);

    dispatch({
      type: SALARY_APPROVE_ALL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_APPROVE_ALL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Hold Salary Record
export const holdSalaryRecord = (id, holdReason) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_HOLD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(`${baseUrl}/salary/${id}/hold`, { holdReason }, config);

    dispatch({
      type: SALARY_HOLD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: SALARY_HOLD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const generateSalary = ({ month, year, company, type }) => async (dispatch, getState) => {
  try {
    dispatch({ type: SALARY_GENERATE_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(`${baseUrl}/salary/generate`, { month, year, company, type }, config);

    dispatch({ type: SALARY_GENERATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SALARY_GENERATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
